import {IAggregationFunction} from "@ispm/dynamic-form/interfaces/IAggregationFunction.interface";
import {EventDataFilterService} from "@ispm/shared/services/event-data-filter.service";
import {get} from "lodash";

export class SumAggregationFunction implements IAggregationFunction{
  public sum = 0
  private eventFilterService: EventDataFilterService = new EventDataFilterService();
  performAggregation(inputData: Array<any>, hasFilter: boolean, filterExpression?: Object) {
    let filteredData: Array<any> = this.eventFilterService.filterDataWithExpression(inputData,hasFilter,filterExpression);
    /*let key = get(filteredData,'key');*/
  /*  filteredData.forEach(element => {
      this.sum = this.sum+element;
    })*/
    let filteredDataInt = filteredData.map(Number);
   if(filteredDataInt.length > 0){
    this.sum =  filteredDataInt.reduce((partialSum,element) => partialSum+element);
    }
    return this.sum;
  }



}
